import React from "react";
var __jsx = React.createElement;
import { useParams } from "react-router-dom";
import stl from "./YearsSelectedTags.module.css";
import YearTag from "./YearTag/YearTag";
import useHelpers from "@hooks/useHelpers";
var YearsSelectedTags = function YearsSelectedTags(_ref) {
  var tags = _ref.tags,
    className = _ref.className;
  var _useParams = useParams(),
    year = _useParams.year;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var createTagUrl = function createTagUrl(tag) {
    if (tag.filterField === "make_id") return createUrl("/years/".concat(year));
    return createUrl("/years"); // !! should be changed to /autos/${make} ???
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-years-selected",
    className: "".concat(stl.wrapper, " ").concat(className || "")
  }, /*#__PURE__*/React.createElement("div", null, tags.map(function (tag, i) {
    return /*#__PURE__*/React.createElement(YearTag, {
      key: i,
      id: "posts-seo-chip-year-selected-".concat(tag.filterField, "-").concat(tag.id),
      title: tag.type === "range" ? tag.range_values.from : tag.name,
      url: createTagUrl(tag)
    });
  })));
};
export default YearsSelectedTags;